import axios from "axios";
import Image from "next/image";
import { useRouter } from "next/router";
import { useState } from "react";
import { useForm } from "react-hook-form";
import PhoneInput from "react-phone-input-2";

const WORK_QUALITY  = "Work Quality";
const ON_TIME_DELIVERY  = "On time delivery";
const BUDGET_FRIENDLY = "Budget Friendly";
const FLEXIBLE_BUSINESS_MODELS = "Flexible Business Models";
const MAINTENANCE_AND_SUPPORT = "Maintenance and Support";
const COMMITMENT_DATA = [
  {
    color: "#F9F6FF",
    image: "/assets/services/work-quality.webp",
    alt: WORK_QUALITY,
    imageTitle: WORK_QUALITY,
    title: WORK_QUALITY,
    description:
      "Our team strictly adheres to international design & coding standards.",
  },
  {
    color: "#FCF6FF",
    image: "/assets/services/on-time.webp",
    alt: ON_TIME_DELIVERY,
    imageTitle: ON_TIME_DELIVERY,
    title: ON_TIME_DELIVERY,
    description:
      "We always provide results in a timely manner with 100% QC. No options!",
  },
  {
    color: "#F4FFFD",
    image: "/assets/services/budget-friendly.webp",
    alt: BUDGET_FRIENDLY,
    imageTitle: BUDGET_FRIENDLY,
    title: BUDGET_FRIENDLY,
    description:
      "We stick to our proven methods and deliver scalable results on a budget.",
  },
  {
    color: "#F5FBFF",
    image: "/assets/services/timely.webp",
    alt: FLEXIBLE_BUSINESS_MODELS,
    imageTitle: FLEXIBLE_BUSINESS_MODELS,
    title: FLEXIBLE_BUSINESS_MODELS,
    description:
      "We have got you covered with multiple business models suiting your needs.",
  },
  {
    color: "#FCF6FF",
    image: "/assets/services/maintenance.webp",
    alt: MAINTENANCE_AND_SUPPORT,
    imageTitle: MAINTENANCE_AND_SUPPORT,
    title: MAINTENANCE_AND_SUPPORT,
    description:
      "We don't just finish tasks; we are here to maintain your product uptime fully.",
  },
];

const Commitment = () => {
  const [phoneValue, setPhoneValue] = useState("");
  const [disabled, setDisabled] = useState(false);
  const router = useRouter();

  const {
    register,
    handleSubmit,
    // eslint-disable-next-line no-unused-vars
    formState: { errors },
  } = useForm();
  const onSubmit = (values) => {
    setDisabled(true);
    axios
      .post("/api/contact", {
        ...values,
        name: values.name,
        email: values.email,
        phone: phoneValue,
        technologyName: "home",
        enquiryPage: router.asPath,
      })
      .then(() => {
        router.push("/thankyou");
      })
      .finally(() => {
        setDisabled(false);
      });
  };

  return (
    <div className="mt-12 pt-4">
      <div className="flex flex-col-reverse md:flex-col xl:flex-row justify-center">
        <div className="w-full xl:w-4/12">
          <div className="p-4 mx-auto rounded-2xl bg-gray-200 bg-opacity-20 w-[350px] lg:w-[420px]">
            <form
              className="flex flex-col my-8"
              onSubmit={handleSubmit(onSubmit)}
            >
              <input
                required
                {...register("name", {
                  required: true,
                  pattern: /^[A-Za-z]/,
                })}
                autoComplete={"off"}
                className="m-4 p-4 border border-solid border-black/10 rounded-lg focus-visible:outline-none"
                id="hireDeveloper"
                placeholder="Full Name*"
              />
              <div className="businessData my-4">
                <PhoneInput
                  country={"us"}
                  enableSearch={true}
                  value={phoneValue}
                  onChange={(value) => setPhoneValue(value)}
                />
              </div>
              <input
                required
                type={"email"}
                {...register("email", {
                  required: true,
                  pattern: /^[\d%+._a-z-]+@[\d.a-z-]+\.[a-z]{2,4}$/,
                })}
                autoComplete={"off"}
                className="m-4 p-4 border border-solid border-black/10 rounded-lg focus-visible:outline-none"
                placeholder="Email ID*"
              />
              <input
                className="w-fit text-sm md:text-lg py-4 px-8 md:px-14 outline-none text-white hover:text-primary-yellow m-4 font-normal rounded-lg bg-primary-yellow hover:bg-transparent border border-solid border-primary-yellow transition-all duration-500 ease-out hover:ease-in cursor-pointer"
                type="submit"
                disabled={disabled}
                value="Reach me quickly"
              ></input>
            </form>
          </div>
        </div>
        <div className="w-full xl:w-8/12">
          <div className="grid grid-cols-1 xl:grid-cols-2 gap-x-6 align-baseline">
            {COMMITMENT_DATA.map((element) => (
              <div key={element.imageTitle}>
                <div
                  className="my-4 p-8 rounded-lg"
                  style={{ background: `${element.color}` }}
                >
                  <div className="fs-0">
                    <Image
                      height={37}
                      src={element.image}
                      title={element.imageTitle}
                      width={37}
                      alt={element.alt}
                    />
                  </div>
                  <h3 className="text-black mt-4 mb-2 text-lg font-medium">
                    <span>{element.title}</span>
                  </h3>
                  <p className="font-light text-sm">
                    <span>{element.description}</span>
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Commitment;
